module.exports = __webpack_public_path__ + "static/media/hotelmontefiore_thumb.33ff9b4a.webp";